import {
	AccordionButton,
	AccordionIcon,
	AccordionItem,
	AccordionPanel,
	Box,
	Button,
	FormControl,
	FormLabel,
	Heading,
	HStack,
	Input,
	Select,
	Tab,
	TabList,
	TabPanel,
	TabPanels,
	Tabs,
	Text,
} from '@chakra-ui/react';

import Preview from '@/components/Preview/Preview';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

interface ISectionButtonProps {
	url: string;
}

export default function SectionButton(props: ISectionButtonProps) {
	const { t } = useTranslation();

	const form = useForm({
		defaultValues: {
			text: 'Schedule a meeting',
			backgroundColor: '#db2777',
			textColor: '#ffffff',
			border: '8',
		},
	});

	const values = form.watch();
	const html = `
<a href="${props.url}" target="_blank"
	style="text-decoration: none; font-weight: 500; border-radius: ${values.border}px; padding: 10px 20px; background-color: ${values.backgroundColor}; color: ${values.textColor};">
	${values.text}
</a>`;

	return (
		<AccordionItem>
			<AccordionButton>
				<Text fontSize="md" fontWeight="500" as="span" flex="1" textAlign="left">
					{t('Add a button to your website')}
				</Text>
				<AccordionIcon />
			</AccordionButton>
			<AccordionPanel pb={4} overflow="auto">
				<Box position="relative" px="20" h="48">
					<Preview>
						<Box display="grid" gridTemplateRows="1fr 1fr 1fr" h="100%">
							<Box
								background="white"
								borderRadius="md"
								display="flex"
								justifyContent="center"
								alignItems="center"
								flexDir="column"
							>
								<Heading textAlign="center" mb="8">
									My amazing website
								</Heading>
								<div dangerouslySetInnerHTML={{ __html: html }}></div>
							</Box>
							<Box background="gray.500" borderRadius="md"></Box>
							<Box background="gray.200" borderRadius="md"></Box>
						</Box>
					</Preview>
				</Box>
				<Box textAlign="center" my="2" color="gray.600">
					<Text>{t('Add a booking button to your website.')}</Text>
					<Text>{t('When clicked, it will open the booking calendar.')}</Text>
				</Box>

				<Box>
					<Tabs>
						<TabList>
							<Tab>{t('Preview')}</Tab>
							<Tab>{t('Customize')}</Tab>
						</TabList>

						<TabPanels>
							<TabPanel>
								<Box
									py="16"
									position="relative"
									background="gray.100"
									borderRadius="md"
									display="flex"
									justifyContent="center"
								>
									<div dangerouslySetInnerHTML={{ __html: html }}></div>
									<Button
										size="xs"
										position="absolute"
										top="2"
										left="2"
										colorScheme="primary"
										onClick={() => {
											navigator.clipboard.writeText(html);
											toast.success(t('Copied to clipboard') as string);
										}}
									>
										{t('Copy HTML code')}
									</Button>
								</Box>
							</TabPanel>

							<TabPanel>
								<HStack>
									<FormControl id="backgroundColor">
										<FormLabel>{t('Color')}</FormLabel>
										<Input {...form.register('backgroundColor')} type="color" size="xs" />
									</FormControl>
									<FormControl id="textColor">
										<FormLabel>{t('Text')}</FormLabel>
										<Input {...form.register('textColor')} type="color" size="xs" />
									</FormControl>
									<FormControl id="border">
										<FormLabel>{t('Border')}</FormLabel>
										<Select {...form.register('border')} size="xs">
											<option value="0">0</option>
											<option value="4">SM</option>
											<option value="8">MD</option>
											<option value="16">LG</option>
										</Select>
									</FormControl>
								</HStack>
								<FormControl mt="2" id="text">
									<FormLabel>{t('Text')}</FormLabel>
									<Input {...form.register('text')} size="xs" />
								</FormControl>
							</TabPanel>
						</TabPanels>
					</Tabs>
				</Box>
			</AccordionPanel>
		</AccordionItem>
	);
}
